import React from "react";
import styles from "./HeaderSliderCard.module.scss";
import { usePopup } from "@/context/PopupContext";

interface HeaderSliderCardProps {
  imageSrc1920: string; // Зображення для 1920px
  imageSrc1440: string; // Зображення для 1440px
  imageSrc768: string; // Зображення для 768px
  imageSrc320: string; // Зображення для 320px
  alt?: string;
  imageType: "full" | "partial"; // Простий тип для вибору типу зображення
  className?: string; // Додатковий клас для спеціальних стилів
}

const HeaderSliderCard: React.FC<HeaderSliderCardProps> = ({
  imageSrc1920,
  imageSrc1440,
  imageSrc768,
  alt = "slide",
  imageType, // Простий тип "full" або "partial"
  className, // Додатковий клас
}) => {
  const { openMenu } = usePopup();

  // Просто визначаємо клас в залежності від imageType
  const imageClass = `${imageType}`;

  return (
    <div
      className={`${styles.card} ${className ? styles[className] : ""}`}
      role="figure"
      aria-label={alt}
    >
      <picture className={styles[imageClass]}>
        {/* WebP версии */}
        <source
          media="(max-width: 768px)"
          srcSet={`${imageSrc768.replace(
            ".png",
            ".webp"
          )} 768w, ${imageSrc1440.replace(".png", ".webp")} 1440w`}
          type="image/webp"
        />
        <source
          media="(max-width: 1024px)"
          srcSet={`${imageSrc1440.replace(
            ".png",
            ".webp"
          )} 1440w, ${imageSrc1920.replace(".png", ".webp")} 1920w`}
          type="image/webp"
        />
        <source
          srcSet={`${imageSrc1440.replace(
            ".png",
            ".webp"
          )} 1440w, ${imageSrc1920.replace(".png", ".webp")} 1920w`}
          type="image/webp"
        />

        {/* PNG версии */}
        <source
          media="(max-width: 768px)"
          srcSet={`${imageSrc768} 768w, ${imageSrc1440} 1440w`}
          type="image/png"
        />
        <source
          media="(max-width: 1024px)"
          srcSet={`${imageSrc1440} 1440w, ${imageSrc1920} 1920w`}
          type="image/png"
        />

        {/* Fallback */}
        <img
          src={imageSrc1920}
          srcSet={`${imageSrc768} 768w, ${imageSrc1440} 1440w, ${imageSrc1920} 1920w`}
          sizes="(max-width: 768px) 768px, (max-width: 1024px) 1440px, 1920px"
          alt={alt}
          className={styles.cardImage}
        />
      </picture>
      <div className={styles.overlay}></div>
      <div className={`container sideP88 ${styles.sliderCont}`}>
        <div className={styles.leftBlock}>
          <h1>Reparatur-Service für DSG-Mechatronik – per Post oder vor Ort</h1>
        </div>
        <div className={styles.rightBlock}>
          <p>
            Präzise Diagnose, hochwertige Reparatur und Wartung auf dem Niveau
            führender Fachzentren.
          </p>
          <button
            className={`commonButton buttonLg ${styles.button}`}
            onClick={openMenu}
          >
            Jetzt anfragen
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderSliderCard;
